import * as React from "react";
import { Button, DrawerHeaderTitle, DrawerHeader as DrawerHeaderFluent, Text, Avatar } from "@fluentui/react-components";
import { Dismiss24Regular } from "@fluentui/react-icons";
import { useTranslation } from 'react-i18next';

interface DrawerHeaderProps {
  logo: string;
  title: string;
  onClose: () => void;
}

const DrawerHeader: React.FC<DrawerHeaderProps> = ({ 
  logo, 
  title, 
  onClose 
}) => {
  const { t } = useTranslation();
  const closeMenuLabel = t('common.cancel', 'Cancel');

  return (
    <DrawerHeaderFluent>
      <DrawerHeaderTitle
        action={
          <Button
            appearance="subtle"
            aria-label={closeMenuLabel}
            icon={<Dismiss24Regular />}
            onClick={onClose}
          />
        }
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          {logo && (
            <Avatar
              size={32}
              image={{ src: logo }}
              name={title}
            />
          )}
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Text size={400} weight="semibold">
              {title}
            </Text>
          </div>
        </div>
      </DrawerHeaderTitle>
    </DrawerHeaderFluent>
  );
};

export default DrawerHeader;